import React from "react";
import { toFixed } from "../CustomComponent";
import HintIcon from "./HintIcon";
import { formBlockStyle, RD_GREEN_DARK } from "./constants";

// ขั้นตอนที่ 2: รายการเงินได้ จัดหัวข้อชุดเดียวกับแบบ ภ.ง.ด.90/91
// แถวไหนยังไม่มีข้อมูลจะขึ้นลิงก์ "ระบุข้อมูล" แถวที่มีแล้วจะโชว์ยอดรวมกับภาษีหัก ณ ที่จ่าย
export default function StepIncome({ catalog, totalsByCategory, onOpen }) {
  const groups = catalog?.rd_income_groups || [];
  const typeMap = (catalog?.income_types || []).reduce((acc, type) => ({ ...acc, [type.value]: type }), {});

  return (
    <div className="p-3 p-md-4" style={formBlockStyle}>
      <div className="row g-2 pb-2 mb-2 border-bottom">
        <div className="col-12 col-lg-6" />
        <div className="col-6 col-lg-3 text-lg-end small text-secondary">เงินได้ทั้งหมด</div>
        <div className="col-6 col-lg-3 text-lg-end small text-secondary">ภาษีหัก ณ ที่จ่าย</div>
      </div>

      {groups.map((group) => (
        <div className="mb-4" key={group.key}>
          <div className="fw-semibold mb-2" style={{ color: RD_GREEN_DARK }}>{group.label}</div>

          {group.categories.map((category) => {
            const type = typeMap[category];
            if (!type) return null;
            const total = totalsByCategory[category];
            const filled = !!total && (total.gross > 0 || total.wht > 0);

            return (
              <div className="row g-2 align-items-center py-2 border-bottom" key={category}>
                <div className="col-12 col-lg-6">
                  <span>{type.label} (มาตรา {type.section})</span>
                  <HintIcon text={type.hint} />
                  {total?.payroll_count > 0 ? (
                    <div className="small text-secondary">ดึงจากสลิปเงินเดือนแล้ว {total.payroll_count} รายการ</div>
                  ) : null}
                </div>

                {filled ? (
                  <>
                    <div className="col-6 col-lg-3 text-lg-end">
                      <button
                        type="button"
                        className="btn btn-link p-0 text-decoration-none fw-semibold"
                        style={{ color: "#12314d" }}
                        onClick={() => onOpen(category)}
                      >
                        {toFixed(total.gross)}
                      </button>
                    </div>
                    <div className="col-6 col-lg-3 text-lg-end d-flex align-items-center justify-content-end gap-2">
                      <span>{toFixed(total.wht)}</span>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary rounded-3 py-0 px-2"
                        title={`แก้ไข ${type.label}`}
                        onClick={() => onOpen(category)}
                      >
                        <i className="fa-solid fa-pen" style={{ fontSize: "0.7rem" }} />
                      </button>
                    </div>
                  </>
                ) : (
                  <div className="col-12 col-lg-6 text-lg-end">
                    <button
                      type="button"
                      className="btn btn-link p-0 text-decoration-none fw-semibold"
                      style={{ color: "#4caf50" }}
                      onClick={() => onOpen(category)}
                    >
                      ระบุข้อมูล
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
